import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  patch,
  post,
  put,
} from "helpers/api_helper"
import {
  DASHBOARD_KPI,
  DASHBOARD_KPI_BOOKING,
  DASHBOARD_KPI_ORDER,
  DASHBOARD_KPI_RATINGS,
  EDIYAH_DASHBOARD,
  WALLET_DASHBOARD,
} from "helpers/url_helper"

export const getDashboardKpi = createAsyncThunk(
  DASHBOARD_KPI,
  async payload => {
    const response = await post(DASHBOARD_KPI, payload)
    return response
  }
)

export const getDashboardKpiOrder = createAsyncThunk(
  DASHBOARD_KPI_ORDER,
  async payload => {
    const response = await post(DASHBOARD_KPI_ORDER, payload)
    return response
  }
)

export const getDashboardKpiBookings = createAsyncThunk(
  DASHBOARD_KPI_BOOKING,
  async payload => {
    const response = await post(DASHBOARD_KPI_BOOKING, payload)
    return response
  }
)

export const getDashboardKpiRatings = createAsyncThunk(
  DASHBOARD_KPI_RATINGS,
  async payload => {
    const response = await post(DASHBOARD_KPI_RATINGS, payload)
    return response
  }
)

export const getEdiyahDashboard = createAsyncThunk(
  EDIYAH_DASHBOARD,
  async payload => {
    const response = await post(EDIYAH_DASHBOARD, payload)
    return response
  }
)

export const getWalletDashboard = createAsyncThunk(
  WALLET_DASHBOARD,
  async payload => {
    const response = await post(WALLET_DASHBOARD, payload)
    return response
  }
)
